import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import { ScrollActivator } from 'acq-components/lib/utils/ScrollActivator/ScrollActivator';
import formStylesDefault from './__styles__/formView.scss?modules';

let toggled = false;

const StickyContainer = React.memo(({ children, formStyles }) => {
  const styles = formStyles || formStylesDefault;
  const wrapElement = useRef(null);

  const MIN_SCROLL_WIDTH = 1023;
  const MIN_SCROLL_HEIGHT = 850;
  const SCROLL_STICKY_CANCEL = 0;
  const SCROLL_STICKY_TOP = 1;
  const SCROLL_STICKY_BOTTOM = 2;

  const scrollHandler = () => {
    if (
      typeof wrapElement?.current?.getBoundingClientRect !== 'function' ||
      typeof wrapElement?.current?.parentElement?.getBoundingClientRect !==
        'function'
    ) {
      return SCROLL_STICKY_CANCEL;
    }

    const parentRect = wrapElement.current.parentElement.getBoundingClientRect();
    const topVal = Math.round(parentRect.top);
    const formRect = wrapElement.current.getBoundingClientRect();
    const panelEnd = Math.round(parentRect.height + parentRect.top);
    const winHeight = window.innerHeight;
    const triggeringY = formRect.height < winHeight ? formRect.height : winHeight;

    if (window.innerWidth >= MIN_SCROLL_WIDTH) {
      if (winHeight <= MIN_SCROLL_HEIGHT) {
        return SCROLL_STICKY_TOP;
      } else if (panelEnd <= triggeringY) {
        return SCROLL_STICKY_BOTTOM;
      } else if (topVal <= 59) {
        return SCROLL_STICKY_TOP;
      }
    }

    return SCROLL_STICKY_CANCEL;
  };

  useEffect(() => {
    /*
    DE574120
    faq Accordion actions will affect the sticky logic here 
    (it was not in the previous corp.vac page).  We are to 
    intercept the action and handle it here.
    */

    let faqView;

    const handleAccordionActions = () => {
      window.scrollBy(0, toggled ? 1 : -1);
      toggled = !toggled;
    };

    setTimeout(() => {
      faqView = document.querySelector('div[class*="purify_faqStyle__faqwrap--"]');
      if (faqView) {
        faqView.addEventListener('click', handleAccordionActions);
      }
    }, 5000);

    return () => {
      if (faqView) {
        faqView.removeEventListener('click', handleAccordionActions);
      }
    };
  }, []);

  return (
    <ScrollActivator onScroll={scrollHandler}>
      {activatedState => {
        const classNameVal = clsx(
          styles.formStickyWrap,
          { [styles.stickyTop]: activatedState === SCROLL_STICKY_TOP },
          { [styles.stickyBottom]: activatedState === SCROLL_STICKY_BOTTOM }
        );
        return (
          <div ref={wrapElement} className={classNameVal}>
            {children}
          </div>
        );
      }}
    </ScrollActivator>
  );
});

export { StickyContainer };
